export default "__VITE_ASSET__Cxj7kspm__"